import type { FlightPlan, Flight, FlightOption } from '../types/flights';
import type { Rate } from '../types/products';

// ////////////////// RATES ////////////////////
const MOCK_FLIGHT_RATE: Rate = {
  type: 'person',
  amount: 100,
  childAmount: 50,
};

// const MOCK_FLIGHT_RATE_BUSINESS: Rate = {
//   type: 'person',
//   amount: 300,
//   childAmount: 100,
// };
// Q: moet er ook een rate voor babies zijn?

// ////////////////// RATES ////////////////////

// ////////////////// MAIN FLIGHTS ////////////////////
// export const MOCK_FLIGHT_WITH_OVERLAY: Flight = {
//   flights: [
//     {
//       id: '1',
//       departureAirport: 'Amsterdam (AMS)',
//       departureDateTime: '2021-12-12 12:00:00',
//       arrivalAirport: 'Porto (OPO)',
//       arrivalDateTime: '2021-12-12 14:00:00',
//       duration: 120,
//       flightNumber: 'AR-453',
//       Rate: MOCK_FLIGHT_RATE,
//       subType: 'direct',
//       supplier: 'Transavia',
//       type: 'outward',
//       class: 'Economy',
//     },
//     {
//       id: '2',
//       departureAirport: 'Porto (OPO)',
//       departureDateTime: '2021-12-12 16:35:00',
//       arrivalAirport: 'Funchal (FXE)',
//       arrivalDateTime: '2021-12-12 19:30:00',
//       duration: 120,
//       flightNumber: 'AR-454',
//       Rate: MOCK_FLIGHT_RATE,
//       subType: 'direct',
//       supplier: 'Transavia',
//       type: 'outward',
//       class: 'Economy',
//     },
//   ],
//   id: '3',
//   departureAirport: 'Amsterdam (AMS)',
//   departureDateTime: '2021-12-12 12:00:00',
//   arrivalAirport: 'Funchal (FXE)',
//   arrivalDateTime: '2021-12-12 17:30:00',
//   duration: 150,
//   flightNumber: 'AR453 - AR454',
//   Rate: MOCK_FLIGHT_RATE,
//   subType: 'indirect',
//   supplier: 'Transavia',
//   type: 'outward',
//   class: 'Economy',
// };

export const MOCK_FLIGHT_WITHOUT_OVERLAY: Flight = {
  id: '4',
  departureAirport: 'Amsterdam (AMS)',
  departureDateTime: '2025-05-01 10:15:00',
  arrivalAirport: 'Oslo (OSL)',
  arrivalDateTime: '2025-05-01 12:00:00',

  duration: 150,
  flightNumber: '',
  Rate: MOCK_FLIGHT_RATE,
  subType: 'direct',
  supplier: 'KLM',
  type: 'outward',
  class: 'Economy',
};

export const MOCK_FLIGHT_WITHOUT_OVERLAY2: Flight = {
  id: '5',
  departureAirport: 'Bergen (BGO)',
  departureDateTime: '2025-05-15 15:15:00',
  arrivalAirport: 'Amsterdam (AMS)',
  arrivalDateTime: '2025-05-15 17:00:00',

  duration: 150,
  flightNumber: '',
  Rate: MOCK_FLIGHT_RATE,
  subType: 'direct',
  supplier: 'KLM',
  type: 'return',
  class: 'Economy',
};
// ////////////////// MAIN FLIGHTS ////////////////////

// ////////////////// BETWEEN FLIGHTS ////////////////////
// export const MOCK_FLIGHT_BETWEEN: Flight = {
//   id: '5',
//   departureAirport: 'Funchal (FXE)',
//   departureDateTime: '2021-12-14 15:00:00',
//   arrivalAirport: 'Ponta Delgada (PDL)',
//   arrivalDateTime: '2021-12-14 16:00:00',

//   duration: 150,
//   flightNumber: '',
//   Rate: MOCK_FLIGHT_RATE,
//   subType: 'direct',
//   supplier: 'Transavia',
//   type: 'between',
//   class: 'Economy',
// };

// export const MOCK_SECOND_FLIGHT_BETWEEN: Flight = {
//   id: '6',
//   departureAirport: 'Funchal (FXE)',
//   departureDateTime: '2021-12-14 20:00:00',
//   arrivalAirport: 'Amsterdam (AMS)',
//   arrivalDateTime: '2021-12-14 21:00:00',

//   duration: 150,
//   flightNumber: '',
//   Rate: MOCK_FLIGHT_RATE,
//   subType: 'direct',
//   supplier: 'Transavia',
//   type: 'between',
//   class: 'Economy',
// };
// ////////////////// BETWEEN FLIGHTS ////////////////////

// ////////////////// ALTERNATIVE FLIGHTS ////////////////////
// export const MOCK_ALTERNATIVE_FLIGHT: Flight = {
//   flights: [
//     {
//       id: '7',
//       departureAirport: 'Amsterdam (AMS)',
//       departureDateTime: '2021-12-12 12:00:00',
//       arrivalAirport: 'Porto (OPO)',
//       arrivalDateTime: '2021-12-12 14:00:00',
//       duration: 120,
//       flightNumber: '',
//       Rate: MOCK_FLIGHT_RATE_BUSINESS,
//       subType: 'direct',
//       supplier: 'Alternative Airline',
//       type: 'outward',
//       class: 'Business',
//     },
//     {
//       id: '8',
//       departureAirport: 'Porto (OPO)',
//       departureDateTime: '2021-12-12 15:30:00',
//       arrivalAirport: 'Funchal (FXE)',
//       arrivalDateTime: '2021-12-12 17:30:00',
//       duration: 120,
//       flightNumber: '',
//       Rate: MOCK_FLIGHT_RATE_BUSINESS,
//       subType: 'direct',
//       supplier: 'Alternative Airline',
//       type: 'outward',
//       class: 'Business',
//     },
//   ],
//   id: '9',
//   departureAirport: 'Amsterdam (AMS)',
//   departureDateTime: '2021-12-12 12:00:00',
//   arrivalAirport: 'Funchal (FXE)',
//   arrivalDateTime: '2021-12-12 17:30:00',
//   duration: 150,
//   flightNumber: '',
//   Rate: MOCK_FLIGHT_RATE_BUSINESS,
//   subType: 'indirect',
//   supplier: 'Alternative Airline',
//   type: 'outward',
//   class: 'Business',
// };

// export const MOCK_SECOND_ALTERNATIVE_FLIGHT: Flight = {
//   id: '10',
//   departureAirport: 'Funchal (FXE)',
//   departureDateTime: '2021-12-15 12:00:00',
//   arrivalAirport: 'Amsterdam (AMS)',
//   arrivalDateTime: '2021-12-15 15:00:00',
//   duration: 150,
//   flightNumber: '',
//   Rate: MOCK_FLIGHT_RATE_BUSINESS,
//   subType: 'direct',
//   supplier: 'KLM',
//   type: 'return',
//   class: 'Economy',
// };

// const MOCK_ALTERNATIVE_BEETWEEN_FLIGHT: Flight = {
//   id: '11',
//   departureAirport: 'Funchal (FXE)',
//   departureDateTime: '2021-12-14 15:00:00',
//   arrivalAirport: 'Amsterdam (AMS)',
//   arrivalDateTime: '2021-12-14 16:00:00',

//   duration: 150,
//   flightNumber: '',
//   Rate: MOCK_FLIGHT_RATE_BUSINESS,
//   subType: 'direct',
//   supplier: 'Alternative Airline',
//   type: 'between',
//   class: 'Business',
// };
// ////////////////// ALTERNATIVE FLIGHTS ////////////////////

// ////////////////// LUGGAGE OPTIONS ////////////////////
const MOCK_FLIGHT_OPTION_CHECKED_LUGGAGE_20: FlightOption = {
  type: 'luggage',
  price: 100,
  name: 'Cabin baggage + Checked baggage',
  description: '1 piece of hand luggage (40 x 30 x 20 cm) & 1 piece of checked luggage (20 kg)',
  selected: false,
};

const MOCK_FLIGHT_OPTION_CHECKED_LUGGAGE_30: FlightOption = {
  type: 'luggage',
  price: 150,
  name: 'Cabin baggage + Checked baggage',
  description: '1 piece of hand luggage (40 x 30 x 20 cm) & 1 piece of checked luggage (30 kg)',
  selected: false,
};

const MOCK_FLIGHT_OPTION_CABIN_LUGGAGE: FlightOption = {
  type: 'luggage',
  price: 50,
  name: 'Cabin baggage',
  description: '1 piece of hand luggage (40 x 30 x 20 cm)',
  selected: true,
  alternate: [MOCK_FLIGHT_OPTION_CHECKED_LUGGAGE_20, MOCK_FLIGHT_OPTION_CHECKED_LUGGAGE_30],
};
// ////////////////// LUGGAGE OPTIONS ////////////////////

// ////////////////// FLIGHTPLANS ////////////////////
// const MOCK_ALTERNATIVE_FLIGHT_PLAN: FlightPlan = {
//   flights: [MOCK_ALTERNATIVE_FLIGHT, MOCK_SECOND_ALTERNATIVE_FLIGHT],
//   selected: false,
//   mainFlight: true,
// };

// const MOCK_ALTERNATIVE_FLIGHT_PLAN_WITH_BETWEEN: FlightPlan = {
//   flights: [MOCK_ALTERNATIVE_BEETWEEN_FLIGHT],
//   selected: false,
//   mainFlight: false,
// };

// export const MOCK_SECOND_FLIGHT_PLAN: FlightPlan = {
//   flights: [MOCK_FLIGHT_BETWEEN],
//   selected: true,
//   mainFlight: false,
//   // alternate: MOCK_ALTERNATIVE_FLIGHT_PLAN_WITH_BETWEEN,
// };

export const MOCK_FLIGHT_PLAN: FlightPlan = {
  // flights: [MOCK_FLIGHT_WITH_OVERLAY, MOCK_FLIGHT_WITHOUT_OVERLAY],
  flights: [MOCK_FLIGHT_WITHOUT_OVERLAY, MOCK_FLIGHT_WITHOUT_OVERLAY2],
  selected: true,
  mainFlight: true,
  // alternate: MOCK_ALTERNATIVE_FLIGHT_PLAN,
  flightOptions: [MOCK_FLIGHT_OPTION_CABIN_LUGGAGE],
};
// ////////////////// FLIGHTPLANS ////////////////////
